import "./Footer.scss";
import logo from "./../Assets/Images/logo.png";
import fontawesome from "@fortawesome/fontawesome";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopyright } from "@fortawesome/free-regular-svg-icons";
import { Link } from "react-router-dom";

const Footer = () => {
  fontawesome.library.add(faCopyright);

  return (
    <footer className="footer-container">
      <div className="footer">
        <div className="footer-brand">
          <Link to="/" className="footer-logo" aria-label="Bayun home">
            <img src={logo} alt="Bayun" />
          </Link>
        </div>

        <nav className="footer-links" aria-label="Legal">
          <Link to="/bayun-terms-of-service">Terms of Service</Link>
          <Link to="/bayun-privacy-policy">Privacy Policy</Link>
        </nav>

        <div className="footer-contact">
          <a href="mailto:contact@bayunsystems.com">contact@bayunsystems.com</a>
          <a href="tel:+16504509951">+1-650-450-9951</a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          <FontAwesomeIcon icon={["far", "copyright"]} /> 2026 Bayun Systems,
          Inc. | All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
